import { connect } from 'react-redux';

import Accounts from '../components/Accounts';

import {
  initAccountDashboard,
  retrieveAccount,
  selectAccount,
  getAccountInstallers,
  toggleSupport,
} from '../actions/account';

const mapStateToProps = (state, ownProps) => ({
  account: state.account,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getAccountInstallers: account => {
    dispatch(getAccountInstallers(account));
  },
  selectAccount: (id, name) => {
    dispatch(selectAccount(id, name));
  },
  initData: () => {
    dispatch(initAccountDashboard());
  },
  retrieveAccount: (email, account, accounts, services, user_id, time_zone) => {
    dispatch(
      retrieveAccount(email, account, accounts, services, user_id, time_zone)
    );
  },
  toggleSupport: account_id => {
    dispatch(toggleSupport(account_id));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Accounts);
